<template>
    <div>
        <v-container fluid pa-0 class="h-100">
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">Finalize Shipment</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="shipment_planner.shipment_id && shipment_planner.shipment_id > 0" @invoke-method="refresh(true)"></bc-btn-refresh>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'shipment_planners' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>
            <v-card elevation="0" class="h-100">
                <v-card-text style="height: calc(100vh - 145px)">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs3 align-self-start pb-0 :pl-0="!$bp.smallScreen" pr-2 pt-2>
                            <v-layout row wrap>
                                <v-flex xs12 v-if="isInternalUser()">
                                    <bc-autocomplete
                                        v-model="shipment_planner.company_id"
                                        :label="$t('lang.company')"
                                        :rules="ifValid('shipment_planners.company_id')"
                                        :items="company_options"
                                        item-value="company_id"
                                        item-text="company"
                                        :disabled="true"
                                        append-icon="lock"
                                    >
                                    </bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 v-if="shipment_planner.company_id">
                                    <bc-autocomplete
                                        v-model="shipment_planner.truck_id"
                                        :label="$t('lang.truck')"
                                        :items="filterTrucks"
                                        item-value="truck_id"
                                        item-text="truck_name"
                                        :rules="ifValid('shipment_planners.truck_id')"
                                        :disabled="shipment_planner.has_products == 1 ? true : false"
                                        :append-icon="shipment_planner.has_products == 1 ? 'lock' : 'arrow_drop_down'"
                                        @change="changeTrailer()"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 v-if="shipment_planner.company_id && checkTruckCompartments">
                                    <bc-autocomplete
                                        v-model="shipment_planner.trailer_id"
                                        :label="$t('lang.trailer')"
                                        :items="filterTrailers"
                                        item-value="truck_id"
                                        item-text="truck_name"
                                        :rules="ifValid('shipment_planners.trailer_id')"
                                        :disabled="shipment_planner.has_products == 1 ? true : false"
                                        :append-icon="shipment_planner.has_products == 1 ? 'lock' : 'arrow_drop_down'"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs6>
                                    <bc-date-picker
                                        v-model="shipment_planner.load_date"
                                        :label="`${$t('lang.load_date')} *`"
                                        :rules="ifValid('shipment_planners.load_date_required')"
                                        :required="true"
                                    ></bc-date-picker>
                                </v-flex>
                                <v-flex xs6>
                                    <bc-date-picker
                                        v-model="shipment_planner.deliver_date"
                                        :label="`${$t('lang.deliver_date')} *`"
                                        :rules="ifValid('shipment_planners.deliver_date_required')"
                                        :required="true"
                                    ></bc-date-picker>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="shipment_planner.delivered_by"
                                        :label="$t('lang.delivered_by')"
                                        :items="drivers"
                                        item-value="people_id"
                                        item-text="combined_name"
                                        :rules="ifValid('shipment_planners.delivered_by')"
                                    ></bc-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs9 class="h-100 pa-2">
                            <h4 class="mb-0">Truck Route Planner</h4>
                            <v-divider></v-divider>
                            <v-layout row wrap class="pa-0">
                                <v-flex xs12 class="mr-2 h-100 pa-0">
                                    <v-data-table
                                        :headers="headers"
                                        :items="updating_table == true ? [] : shipment_planner.shipment_planner_details || []"
                                        v-sortable-data-table
                                        @sorted="indexRoute()"
                                        hide-actions
                                    >
                                        <template slot="no-data">
                                            <tr class="text-xs-center">
                                                <td colspan="5" class="text-xs-center">
                                                    <v-progress-circular
                                                        v-if="updating_table"
                                                        indeterminate
                                                        color="primary"
                                                        size="24"
                                                        class="mr-2"
                                                    ></v-progress-circular>
                                                    {{ updating_table == true ? "Refreshing Data..." : "No data available" }}
                                                </td>
                                            </tr>
                                        </template>
                                        <template slot="items" slot-scope="props">
                                            <tr>
                                                <td><v-icon class="drag-handle" style="cursor: pointer">drag_indicator</v-icon></td>
                                                <td class="pt-2 pb-2">
                                                    <strong v-if="props.item.ship_location_label">
                                                        {{ props.item.ship_location_label }}
                                                    </strong>
                                                    <div>
                                                        {{ props.item.ship_address1 }}
                                                    </div>
                                                    <div v-if="props.item.ship_address2 != ''">
                                                        {{ props.item.ship_address2 }}
                                                    </div>
                                                    <div>
                                                        {{ props.item.ship_city }}, {{ props.item.ship_state }},
                                                        {{ props.item.ship_zip_code }}
                                                    </div>
                                                    <div>
                                                        {{ props.item.ship_country_iso_3 }}
                                                    </div>
                                                </td>
                                                <td class="pt-2">
                                                    <v-select
                                                        v-model="props.item.fuel_surcharge"
                                                        :items="[
                                                            { text: 'Yes', value: '1' },
                                                            { text: 'No', value: '0' },
                                                        ]"
                                                        :rules="ifValid('shipment_planners.shipment_planner_details.fuel_surcharge')"
                                                        :disabled="shipment_planner.status_id == 6"
                                                    >
                                                    </v-select>
                                                </td>
                                                <td class="pt-2">
                                                    <bc-date-picker
                                                        v-model="props.item.estimated_deliver_date"
                                                        :rules="ifValid('shipment_planners.shipment_planner_details.estimated_delivery_date')"
                                                        :disabled="shipment_planner.status_id == 6"
                                                    ></bc-date-picker>
                                                </td>
                                                <td>
                                                    {{ props.item.products }}
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions style="position: absolute; bottom: 0px; right: 0px">
                    <v-spacer></v-spacer>
                    <v-btn @mouseup.left="$router.push({ name: 'shipment_planner', params: { id: $route.params.id } })" flat>{{ $t("lang.cancel") }}</v-btn>
                    <v-btn :disabled="canSave" color="success" @click="saveShipmentPlanners">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>

            <delete-confirmation-dialog
                ref="delete_shipment_planner"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_shipment_planner')"
                :message="$t('lang.delete_shipment_planner_confirm')"
                @onConfirm="deleteShipmentPlanners()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_shipment_planner_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteShipmentPlannerDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { Container, Draggable } from "vue-dndrop";
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import { Drag, Drop, DropMask } from "vue-easy-dnd";

export default {
    components: {
        Drag,
        Drop,
        DropMask,
        Container,
        Draggable,
    },
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            shipment_planner: {},
            file_name: "",
            dbGetShipmentPlanner: _.debounce(this.getShipmentPlanner, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
            tanker_truck: {},
            loads: [],
            transaction_documents: [],
            shipment_planner_dialog: false,
            drivers: [],
            tanker_trailer: {},
            canSave: false,
            stopSave: [],
            updating_table: false,
            headers: [
                { text: "", sortable: false },
                { text: "Destination", sortable: false },
                { text: "Fuel Surcharge", sortable: false },
                { text: "Est Delivery", sortable: false },
                { text: "Product(s)", sortable: false },
            ],
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;
        this.$store.commit("toggleMainMenu", false);
        if (id !== "undefined") {
            this.$store
                .dispatch("fetchShipmentPlanner", {
                    id: id,
                    body: {
                        by_order: 1,
                    },
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.shipment_planner) {
                        this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
                        if (this.shipment_planner.shipment_planner_details == null) {
                            this.$router.push({ name: "shipment_planner", params: { id: id } });
                        }

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=shipment_planner_status&sort_by=2",
                            method: "get",
                            stateProperty: "shipment_planner_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "shipment_planners", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            const id = `${to.params.id}`;
            vm.$store.commit("toggleMainMenu", false);
            if (id !== "undefined") {
                store
                    .dispatch("fetchShipmentPlanner", {
                        id: id,
                        body: {
                            by_order: 1,
                        },
                    })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.shipment_planner) {
                            vm.shipment_planner = vm.assignObj2(data.shipment_planner, vm.rules_shipment_planners);
                            if (vm.shipment_planner.shipment_planner_details == null) {
                                vm.$router.push({ name: "shipment_planner", params: { id: id } });
                            }

                            store.dispatch("fetchSetting", {
                                url: "options?slug=shipment_planner_status&sort_by=2",
                                method: "get",
                                stateProperty: "shipment_planner_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        } else {
                            next({ name: "shipment_planners", replace: true });
                        }
                    });
            } else {
                vm.finishLoader();
            }
        });
    },
    computed: {
        ...mapState({
            rules_shipment_planners: (state) => state.shipment_planners.rules_shipment_planners,
            shipment_planner_status_options: (state) => state.settings.shipment_planner_status,
            shipment_planners: (state) => state.shipment_planners.shipment_planners,
            selectedShipmentPlanner: (state) => state.shipment_planners.selectedShipmentPlanner,
            tanker_trucks: (state) => state.tanker_trucks.tanker_truck_options,
            selectedCustomer: (state) => state.customers.selectedCustomer,
            current_docs: (state) => state.transaction_documents.transaction_document_options,
            company_options: (state) => state.companies.company_options,
        }),
        filterTrucks() {
            return this.tanker_trucks.length > 0
                ? this.tanker_trucks.filter((truck) => truck.company_id == this.shipment_planner.company_id && truck.vehicle_type == "truck")
                : [];
        },
        filterTrailers() {
            return this.tanker_trucks.length > 0
                ? this.tanker_trucks.filter((truck) => truck.company_id == this.shipment_planner.company_id && truck.vehicle_type == "trailer")
                : [];
        },
        checkTruckCompartments() {
            let truck = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.truck_id);
            return truck != undefined && truck.num_of_compartments > 0 ? false : true;
        },
        checkTrailerCompartments() {
            return this.tanker_trucks.length > 0 ? this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.trailer_id) : [];
        },
    },
    methods: {
        ...mapActions([
            "fetchShipmentPlanner",
            "saveShipmentPlanner",
            "deleteShipmentPlanner",
            "printShipmentPlanner",
            "fetchTankerTrucks",
            "fetchTransactionDocuments",
            "fetchCustomer",
            "validationOn",
            "fetchCompanies",
            "fetchPeople",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        getShipmentPlanner(pg_refresh = false) {
            this.startLoader();

            this.fetchShipmentPlanner({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.shipment_planner) {
                    this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printShipmentPlanner({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.shipment_planner) {
                    if (this.dev_mode) {
                        this.file_name = data.shipment_planner.file_name;
                    } else {
                        this.$refs.print.printReport(data.shipment_planner.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveShipmentPlanners() {
            this.validationOn();
            this.$nextTick(() => {
                let body = this.prepForm(this.shipment_planner, this.rules_shipment_planners);

                this.saveShipmentPlanner({
                    body: body,
                }).then((data) => {
                    if (typeof data != "undefined" && data.shipment_planner) {
                        this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
                        if (this.shipment_planner.shipment_planner_details == null) this.shipment_planner.shipment_planner_details = [];
                        this.shipment_planner_dialog = false;
                        this.validationOff();
                    } else {
                    }
                });
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { shipment_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveShipmentPlanner({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.shipment_planner) {
                    this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
                    if (this.shipment_planner.shipment_planner_details == null) this.shipment_planner.shipment_planner_details = [];
                    this.status_loader = false;
                }
            });
        },
        deleteShipmentPlanners() {
            this.deleteShipmentPlanner({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "shipment_planners" });
                }
                this.toggleModalLoader(false);
            });
        },
        range(min, max) {
            var array = [],
                j = 0;
            for (var i = min; i <= max; i++) {
                array[j] = i;
                j++;
            }
            return array;
        },
        getDrivers(company_id) {
            this.fetchPeople({ body: { options: 1, company_id: company_id } }).then((data) => {
                if (typeof data !== "undefined" && data.people) {
                    this.drivers = data.people;

                    if (this.shipment_planner.delivered_by) {
                        this.shipment_planner.delivered_by = this.drivers.find((driver) => driver.people_id == this.shipment_planner.delivered_by).people_id;
                    }
                }
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchShipmentPlanner({
                    id: `${this.$route.params.id}`,
                    body: {
                        by_order: 1,
                    },
                }).then((data) => {
                    if (typeof data !== "undefined" && data.shipment_planner) {
                        this.shipment_planner = this.assignObj2(data.shipment_planner, this.rules_shipment_planners);
                        if (this.shipment_planner.shipment_planner_details == null) {
                            this.$router.push({ name: "shipment_planner", params: { id: this.$route.params.id } });
                        }
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.tanker_trucks.length == 0 || force == true) {
                await this.fetchTankerTrucks({ body: { options: 1 } }).then((data) => {
                    if (typeof data !== "undefined" && data.tanker_trucks) {
                        this.tanker_truck = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.truck_id);
                        this.tanker_trailer = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.trailer_id);
                    }
                });
            } else {
                this.tanker_truck = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.truck_id);
                this.tanker_trailer = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.trailer_id);
            }

            if (this.transaction_documents.length == 0 || force == true) {
                await this.fetchTransactionDocuments({ body: { company_id: this.shipment_planner.company_id, status: "open", options: 1 } }).then((data) => {
                    if (typeof data !== "undefined" && data.transaction_documents) {
                        this.transaction_documents = JSON.parse(JSON.stringify(data.transaction_documents));
                    }
                });
            }

            if (this.shipment_planner.company_id) {
                this.fetchCustomer({
                    id: this.shipment_planner.company_id,
                });
            }

            if (this.company_options.length == 0 || force == true) await this.fetchCompanies({ body: { options: 1 } });

            if (this.drivers.length == 0 || force == true) {
                this.getDrivers(this.shipment_planner.company_id);
            }

            this.setDefaultDates();
        },
        showShipment() {
            this.shipment_planner_dialog = true;
        },
        closeShipmentPlannerDialog() {
            this.shipment_planner_dialog = false;
            this.validationOff();
            this.toggleModalLoader(false);
        },
        formatNumberWithCommas(number) {
            return number.toLocaleString("en-US");
        },
        changeTrailer() {
            if (this.tanker_trucks.filter((truck) => truck.truck_id == this.shipment_planner.truck_id)[0].num_of_compartments > 0) {
                this.shipment_planner.trailer_id = null;
            }
        },
        indexRoute() {
            let index = 0;
            this.shipment_planner.shipment_planner_details.forEach((item) => {
                item.route_order = index;
                index++;
            });
        },
        setDefaultDates() {
            this.shipment_planner.shipment_planner_details.forEach((item) => {
                if (item.estimated_deliver_date == null) {
                    // set to todays date
                    item.estimated_deliver_date = new Date().toISOString().split("T")[0];
                }
            });
        },
    },
    created() {},
};
</script>
<style>
.mask {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid black;
    background-color: rgba(255, 0, 0, 0.2);
    width: 200px;
    height: 100px;
}

.mask::before {
    content: "MASK";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: rgba(0, 0, 0, 0.4);
    font-size: 25px;
    font-weight: bold;
}

.drop-allowed {
    background-color: rgba(0, 255, 0, 0.2);
}

.drop-forbidden {
    background-color: rgba(255, 0, 0, 0.2);
}

.drop-in {
    box-shadow: 0 0 5px rgba(0, 0, 255, 0.4);
}

.list-enter,
.list-leave-to {
    opacity: 0;
}

.list-leave-active {
    position: absolute;
}

.small-text-field.v-text-field--outline > .v-input__control > .v-input__slot {
    min-height: 28px !important;
    background-color: white !important;
    padding: 0 4px !important;
}

.small-text-field.v-text-field--outline input {
    margin-top: 0px !important;
    background-color: white !important;
    text-align: left;
}

.red-color {
    color: red !important;
}

.white-color {
    color: white !important;
}
</style>
